@if (url === '') {
  <div class="zwi-avatar"></div>
} @else {
  <img [src]="url" class="zwi-avatar">
}
